import type { Locale } from './constants';
import { MOMENT_LOCALE_NAMES } from './constants';

export const sortLocales = (locales: Locale[]): Locale[] => {
  // sort locales alphabetically according to their ISO 639-1 locale code
  return locales.sort((locale1: Locale, locale2: Locale) => {
    const shortLocaleName1 = MOMENT_LOCALE_NAMES[locale1];
    const shortLocaleName2 = MOMENT_LOCALE_NAMES[locale2];
    return shortLocaleName1.localeCompare(shortLocaleName2);
  });
};
